export const fnr = (x: string) => x.replace(/(?=.{5}$)/, " ");
